// GENERATED FILE - do not edit.
// Produced by packages/checks/src/cli/generate-icon-set.ts.
// Run `pnpm generate` to regenerate.

import type { Icon } from '@phosphor-icons/react';
import { AlignLeft } from '@phosphor-icons/react/dist/csr/AlignLeft';
import { ArrowBendDownLeft } from '@phosphor-icons/react/dist/csr/ArrowBendDownLeft';
import { ArrowBendDownRight } from '@phosphor-icons/react/dist/csr/ArrowBendDownRight';
import { ArrowBendUpLeft } from '@phosphor-icons/react/dist/csr/ArrowBendUpLeft';
import { ArrowBendUpRight } from '@phosphor-icons/react/dist/csr/ArrowBendUpRight';
import { ArrowCounterClockwise } from '@phosphor-icons/react/dist/csr/ArrowCounterClockwise';
import { ArrowDown } from '@phosphor-icons/react/dist/csr/ArrowDown';
import { ArrowDownLeft } from '@phosphor-icons/react/dist/csr/ArrowDownLeft';
import { ArrowDownRight } from '@phosphor-icons/react/dist/csr/ArrowDownRight';
import { ArrowFatLeft } from '@phosphor-icons/react/dist/csr/ArrowFatLeft';
import { ArrowFatRight } from '@phosphor-icons/react/dist/csr/ArrowFatRight';
import { ArrowLeft } from '@phosphor-icons/react/dist/csr/ArrowLeft';
import { ArrowLineLeft } from '@phosphor-icons/react/dist/csr/ArrowLineLeft';
import { ArrowLineRight } from '@phosphor-icons/react/dist/csr/ArrowLineRight';
import { ArrowRight } from '@phosphor-icons/react/dist/csr/ArrowRight';
import { ArrowSquareOut } from '@phosphor-icons/react/dist/csr/ArrowSquareOut';
import { ArrowUUpLeft } from '@phosphor-icons/react/dist/csr/ArrowUUpLeft';
import { ArrowUUpRight } from '@phosphor-icons/react/dist/csr/ArrowUUpRight';
import { ArrowUp } from '@phosphor-icons/react/dist/csr/ArrowUp';
import { ArrowUpLeft } from '@phosphor-icons/react/dist/csr/ArrowUpLeft';
import { ArrowUpRight } from '@phosphor-icons/react/dist/csr/ArrowUpRight';
import { ArrowsClockwise } from '@phosphor-icons/react/dist/csr/ArrowsClockwise';
import { ArrowsLeftRight } from '@phosphor-icons/react/dist/csr/ArrowsLeftRight';
import { Article } from '@phosphor-icons/react/dist/csr/Article';
import { Backspace } from '@phosphor-icons/react/dist/csr/Backspace';
import { Bell } from '@phosphor-icons/react/dist/csr/Bell';
import { BellRinging } from '@phosphor-icons/react/dist/csr/BellRinging';
import { BookOpen } from '@phosphor-icons/react/dist/csr/BookOpen';
import { Briefcase } from '@phosphor-icons/react/dist/csr/Briefcase';
import { Browser } from '@phosphor-icons/react/dist/csr/Browser';
import { Building } from '@phosphor-icons/react/dist/csr/Building';
import { Buildings } from '@phosphor-icons/react/dist/csr/Buildings';
import { Calendar } from '@phosphor-icons/react/dist/csr/Calendar';
import { CalendarBlank } from '@phosphor-icons/react/dist/csr/CalendarBlank';
import { CalendarDots } from '@phosphor-icons/react/dist/csr/CalendarDots';
import { CaretDoubleLeft } from '@phosphor-icons/react/dist/csr/CaretDoubleLeft';
import { CaretDoubleRight } from '@phosphor-icons/react/dist/csr/CaretDoubleRight';
import { CaretDown } from '@phosphor-icons/react/dist/csr/CaretDown';
import { CaretLeft } from '@phosphor-icons/react/dist/csr/CaretLeft';
import { CaretLineLeft } from '@phosphor-icons/react/dist/csr/CaretLineLeft';
import { CaretLineRight } from '@phosphor-icons/react/dist/csr/CaretLineRight';
import { CaretRight } from '@phosphor-icons/react/dist/csr/CaretRight';
import { ChartBar } from '@phosphor-icons/react/dist/csr/ChartBar';
import { Chat } from '@phosphor-icons/react/dist/csr/Chat';
import { ChatCircle } from '@phosphor-icons/react/dist/csr/ChatCircle';
import { ChatText } from '@phosphor-icons/react/dist/csr/ChatText';
import { Check } from '@phosphor-icons/react/dist/csr/Check';
import { CheckCircle } from '@phosphor-icons/react/dist/csr/CheckCircle';
import { CheckSquare } from '@phosphor-icons/react/dist/csr/CheckSquare';
import { Circle } from '@phosphor-icons/react/dist/csr/Circle';
import { CircleDashed } from '@phosphor-icons/react/dist/csr/CircleDashed';
import { City } from '@phosphor-icons/react/dist/csr/City';
import { ClipboardText } from '@phosphor-icons/react/dist/csr/ClipboardText';
import { Clock } from '@phosphor-icons/react/dist/csr/Clock';
import { ClockCounterClockwise } from '@phosphor-icons/react/dist/csr/ClockCounterClockwise';
import { CloudArrowUp } from '@phosphor-icons/react/dist/csr/CloudArrowUp';
import { CloudSlash } from '@phosphor-icons/react/dist/csr/CloudSlash';
import { Code } from '@phosphor-icons/react/dist/csr/Code';
import { Columns } from '@phosphor-icons/react/dist/csr/Columns';
import { Command } from '@phosphor-icons/react/dist/csr/Command';
import { Copy } from '@phosphor-icons/react/dist/csr/Copy';
import { Cpu } from '@phosphor-icons/react/dist/csr/Cpu';
import { CreditCard } from '@phosphor-icons/react/dist/csr/CreditCard';
import { Cube } from '@phosphor-icons/react/dist/csr/Cube';
import { CursorClick } from '@phosphor-icons/react/dist/csr/CursorClick';
import { Desktop } from '@phosphor-icons/react/dist/csr/Desktop';
import { DeviceMobile } from '@phosphor-icons/react/dist/csr/DeviceMobile';
import { Diamond } from '@phosphor-icons/react/dist/csr/Diamond';
import { DotsThreeVertical } from '@phosphor-icons/react/dist/csr/DotsThreeVertical';
import { Download } from '@phosphor-icons/react/dist/csr/Download';
import { Empty } from '@phosphor-icons/react/dist/csr/Empty';
import { Envelope } from '@phosphor-icons/react/dist/csr/Envelope';
import { EnvelopeOpen } from '@phosphor-icons/react/dist/csr/EnvelopeOpen';
import { Export } from '@phosphor-icons/react/dist/csr/Export';
import { Eye } from '@phosphor-icons/react/dist/csr/Eye';
import { EyeSlash } from '@phosphor-icons/react/dist/csr/EyeSlash';
import { File } from '@phosphor-icons/react/dist/csr/File';
import { FilePlus } from '@phosphor-icons/react/dist/csr/FilePlus';
import { FileText } from '@phosphor-icons/react/dist/csr/FileText';
import { FloppyDisk } from '@phosphor-icons/react/dist/csr/FloppyDisk';
import { FlowArrow } from '@phosphor-icons/react/dist/csr/FlowArrow';
import { Funnel } from '@phosphor-icons/react/dist/csr/Funnel';
import { Gear } from '@phosphor-icons/react/dist/csr/Gear';
import { GitBranch } from '@phosphor-icons/react/dist/csr/GitBranch';
import { Globe } from '@phosphor-icons/react/dist/csr/Globe';
import { GridFour } from '@phosphor-icons/react/dist/csr/GridFour';
import { Hammer } from '@phosphor-icons/react/dist/csr/Hammer';
import { Handshake } from '@phosphor-icons/react/dist/csr/Handshake';
import { Hash } from '@phosphor-icons/react/dist/csr/Hash';
import { Hourglass } from '@phosphor-icons/react/dist/csr/Hourglass';
import { House } from '@phosphor-icons/react/dist/csr/House';
import { Image } from '@phosphor-icons/react/dist/csr/Image';
import { Info } from '@phosphor-icons/react/dist/csr/Info';
import { Invoice } from '@phosphor-icons/react/dist/csr/Invoice';
import { Key } from '@phosphor-icons/react/dist/csr/Key';
import { Laptop } from '@phosphor-icons/react/dist/csr/Laptop';
import { Lifebuoy } from '@phosphor-icons/react/dist/csr/Lifebuoy';
import { Lightning } from '@phosphor-icons/react/dist/csr/Lightning';
import { Link } from '@phosphor-icons/react/dist/csr/Link';
import { LinkBreak } from '@phosphor-icons/react/dist/csr/LinkBreak';
import { List } from '@phosphor-icons/react/dist/csr/List';
import { ListChecks } from '@phosphor-icons/react/dist/csr/ListChecks';
import { ListDashes } from '@phosphor-icons/react/dist/csr/ListDashes';
import { Lock } from '@phosphor-icons/react/dist/csr/Lock';
import { LockOpen } from '@phosphor-icons/react/dist/csr/LockOpen';
import { MagnifyingGlass } from '@phosphor-icons/react/dist/csr/MagnifyingGlass';
import { MagnifyingGlassMinus } from '@phosphor-icons/react/dist/csr/MagnifyingGlassMinus';
import { MapPin } from '@phosphor-icons/react/dist/csr/MapPin';
import { Megaphone } from '@phosphor-icons/react/dist/csr/Megaphone';
import { Minus } from '@phosphor-icons/react/dist/csr/Minus';
import { Note } from '@phosphor-icons/react/dist/csr/Note';
import { Package } from '@phosphor-icons/react/dist/csr/Package';
import { PaperPlaneRight } from '@phosphor-icons/react/dist/csr/PaperPlaneRight';
import { PaperPlaneTilt } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt';
import { Paperclip } from '@phosphor-icons/react/dist/csr/Paperclip';
import { Path } from '@phosphor-icons/react/dist/csr/Path';
import { Pause } from '@phosphor-icons/react/dist/csr/Pause';
import { Pencil } from '@phosphor-icons/react/dist/csr/Pencil';
import { PencilSimple } from '@phosphor-icons/react/dist/csr/PencilSimple';
import { Percent } from '@phosphor-icons/react/dist/csr/Percent';
import { Person } from '@phosphor-icons/react/dist/csr/Person';
import { Phone } from '@phosphor-icons/react/dist/csr/Phone';
import { Play } from '@phosphor-icons/react/dist/csr/Play';
import { Plug } from '@phosphor-icons/react/dist/csr/Plug';
import { Plus } from '@phosphor-icons/react/dist/csr/Plus';
import { Printer } from '@phosphor-icons/react/dist/csr/Printer';
import { Prohibit } from '@phosphor-icons/react/dist/csr/Prohibit';
import { Pulse } from '@phosphor-icons/react/dist/csr/Pulse';
import { PushPin } from '@phosphor-icons/react/dist/csr/PushPin';
import { Question } from '@phosphor-icons/react/dist/csr/Question';
import { Quotes } from '@phosphor-icons/react/dist/csr/Quotes';
import { Receipt } from '@phosphor-icons/react/dist/csr/Receipt';
import { Robot } from '@phosphor-icons/react/dist/csr/Robot';
import { Rows } from '@phosphor-icons/react/dist/csr/Rows';
import { SealCheck } from '@phosphor-icons/react/dist/csr/SealCheck';
import { Shapes } from '@phosphor-icons/react/dist/csr/Shapes';
import { ShieldCheck } from '@phosphor-icons/react/dist/csr/ShieldCheck';
import { ShoppingBag } from '@phosphor-icons/react/dist/csr/ShoppingBag';
import { Sidebar } from '@phosphor-icons/react/dist/csr/Sidebar';
import { SidebarSimple } from '@phosphor-icons/react/dist/csr/SidebarSimple';
import { Sigma } from '@phosphor-icons/react/dist/csr/Sigma';
import { SignIn } from '@phosphor-icons/react/dist/csr/SignIn';
import { SignOut } from '@phosphor-icons/react/dist/csr/SignOut';
import { Signature } from '@phosphor-icons/react/dist/csr/Signature';
import { SkipBack } from '@phosphor-icons/react/dist/csr/SkipBack';
import { SkipForward } from '@phosphor-icons/react/dist/csr/SkipForward';
import { SlidersHorizontal } from '@phosphor-icons/react/dist/csr/SlidersHorizontal';
import { Sparkle } from '@phosphor-icons/react/dist/csr/Sparkle';
import { Spinner } from '@phosphor-icons/react/dist/csr/Spinner';
import { SquaresFour } from '@phosphor-icons/react/dist/csr/SquaresFour';
import { Stack } from '@phosphor-icons/react/dist/csr/Stack';
import { Steps } from '@phosphor-icons/react/dist/csr/Steps';
import { Stop } from '@phosphor-icons/react/dist/csr/Stop';
import { StopCircle } from '@phosphor-icons/react/dist/csr/StopCircle';
import { Table } from '@phosphor-icons/react/dist/csr/Table';
import { Tag } from '@phosphor-icons/react/dist/csr/Tag';
import { Target } from '@phosphor-icons/react/dist/csr/Target';
import { TextIndent } from '@phosphor-icons/react/dist/csr/TextIndent';
import { TextOutdent } from '@phosphor-icons/react/dist/csr/TextOutdent';
import { TextT } from '@phosphor-icons/react/dist/csr/TextT';
import { Ticket } from '@phosphor-icons/react/dist/csr/Ticket';
import { ToggleLeft } from '@phosphor-icons/react/dist/csr/ToggleLeft';
import { ToggleRight } from '@phosphor-icons/react/dist/csr/ToggleRight';
import { Trash } from '@phosphor-icons/react/dist/csr/Trash';
import { Tray } from '@phosphor-icons/react/dist/csr/Tray';
import { TrendDown } from '@phosphor-icons/react/dist/csr/TrendDown';
import { TrendUp } from '@phosphor-icons/react/dist/csr/TrendUp';
import { Truck } from '@phosphor-icons/react/dist/csr/Truck';
import { Upload } from '@phosphor-icons/react/dist/csr/Upload';
import { User } from '@phosphor-icons/react/dist/csr/User';
import { UserCheck } from '@phosphor-icons/react/dist/csr/UserCheck';
import { UserGear } from '@phosphor-icons/react/dist/csr/UserGear';
import { UserMinus } from '@phosphor-icons/react/dist/csr/UserMinus';
import { UserPlus } from '@phosphor-icons/react/dist/csr/UserPlus';
import { Users } from '@phosphor-icons/react/dist/csr/Users';
import { UsersThree } from '@phosphor-icons/react/dist/csr/UsersThree';
import { Video } from '@phosphor-icons/react/dist/csr/Video';
import { Warehouse } from '@phosphor-icons/react/dist/csr/Warehouse';
import { Warning } from '@phosphor-icons/react/dist/csr/Warning';
import { WarningCircle } from '@phosphor-icons/react/dist/csr/WarningCircle';
import { X } from '@phosphor-icons/react/dist/csr/X';
import { XCircle } from '@phosphor-icons/react/dist/csr/XCircle';

/**
 * Every icon this product names, and no others.
 *
 * One module per icon rather than the package barrel, which carries all
 * 1,512 and four times the bundle with them.
 */
export const ICON_SET = {
  AlignLeft,
  ArrowBendDownLeft,
  ArrowBendDownRight,
  ArrowBendUpLeft,
  ArrowBendUpRight,
  ArrowCounterClockwise,
  ArrowDown,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowFatLeft,
  ArrowFatRight,
  ArrowLeft,
  ArrowLineLeft,
  ArrowLineRight,
  ArrowRight,
  ArrowSquareOut,
  ArrowUUpLeft,
  ArrowUUpRight,
  ArrowUp,
  ArrowUpLeft,
  ArrowUpRight,
  ArrowsClockwise,
  ArrowsLeftRight,
  Article,
  Backspace,
  Bell,
  BellRinging,
  BookOpen,
  Briefcase,
  Browser,
  Building,
  Buildings,
  Calendar,
  CalendarBlank,
  CalendarDots,
  CaretDoubleLeft,
  CaretDoubleRight,
  CaretDown,
  CaretLeft,
  CaretLineLeft,
  CaretLineRight,
  CaretRight,
  ChartBar,
  Chat,
  ChatCircle,
  ChatText,
  Check,
  CheckCircle,
  CheckSquare,
  Circle,
  CircleDashed,
  City,
  ClipboardText,
  Clock,
  ClockCounterClockwise,
  CloudArrowUp,
  CloudSlash,
  Code,
  Columns,
  Command,
  Copy,
  Cpu,
  CreditCard,
  Cube,
  CursorClick,
  Desktop,
  DeviceMobile,
  Diamond,
  DotsThreeVertical,
  Download,
  Empty,
  Envelope,
  EnvelopeOpen,
  Export,
  Eye,
  EyeSlash,
  File,
  FilePlus,
  FileText,
  FloppyDisk,
  FlowArrow,
  Funnel,
  Gear,
  GitBranch,
  Globe,
  GridFour,
  Hammer,
  Handshake,
  Hash,
  Hourglass,
  House,
  Image,
  Info,
  Invoice,
  Key,
  Laptop,
  Lifebuoy,
  Lightning,
  Link,
  LinkBreak,
  List,
  ListChecks,
  ListDashes,
  Lock,
  LockOpen,
  MagnifyingGlass,
  MagnifyingGlassMinus,
  MapPin,
  Megaphone,
  Minus,
  Note,
  Package,
  PaperPlaneRight,
  PaperPlaneTilt,
  Paperclip,
  Path,
  Pause,
  Pencil,
  PencilSimple,
  Percent,
  Person,
  Phone,
  Play,
  Plug,
  Plus,
  Printer,
  Prohibit,
  Pulse,
  PushPin,
  Question,
  Quotes,
  Receipt,
  Robot,
  Rows,
  SealCheck,
  Shapes,
  ShieldCheck,
  ShoppingBag,
  Sidebar,
  SidebarSimple,
  Sigma,
  SignIn,
  SignOut,
  Signature,
  SkipBack,
  SkipForward,
  SlidersHorizontal,
  Sparkle,
  Spinner,
  SquaresFour,
  Stack,
  Steps,
  Stop,
  StopCircle,
  Table,
  Tag,
  Target,
  TextIndent,
  TextOutdent,
  TextT,
  Ticket,
  ToggleLeft,
  ToggleRight,
  Trash,
  Tray,
  TrendDown,
  TrendUp,
  Truck,
  Upload,
  User,
  UserCheck,
  UserGear,
  UserMinus,
  UserPlus,
  Users,
  UsersThree,
  Video,
  Warehouse,
  Warning,
  WarningCircle,
  X,
  XCircle,
} as const satisfies Record<string, Icon>;

export type GeneratedIconName = keyof typeof ICON_SET;
